import { type InjectionKey, type Ref } from "vue";

export const themeKey = Symbol() as InjectionKey<Ref<string>>;
